import React from 'react';
import PropTypes from 'prop-types';
import {
  Section,
  SectionDetails,
  SectionSeparator,
  SectionSummary,
  SectionSummaryDescription,
  SectionSummaryTitle,
} from './styles';
import TextArea from '../../../shared/text-area';
import defaultOnErrorHandler from '../../../../shared/default-on-error-handler';
import { usePostUpdateHeadlineGrab } from '../../../../services/profiles/contributor-settings-service';

export default function HeadlineGrab({ headlineGrab, onUpdate }) {
  const [{ loading, error }, post] = usePostUpdateHeadlineGrab();

  React.useEffect(() => {
    error && defaultOnErrorHandler(error, 'Error saving headline grab');
  }, [error]);

  const label = 'Your Headline';
  const taProps = {
    label,
    value: headlineGrab,
    placeholder: label,
    height: 110,
    isLoading: loading,
    onChange: v => post(v).then(() => onUpdate({ headlineGrab: v })),
  };

  return (
    <>
      <SectionSeparator />
      <Section className="form-group">
        <SectionSummary>
          <SectionSummaryTitle>Your Headline Grab</SectionSummaryTitle>
          <SectionSummaryDescription>
            Your attention grabbing quote you want the audience to see first.
            Get their attention in one short headline statement.
          </SectionSummaryDescription>
        </SectionSummary>
        <SectionDetails>
          <TextArea {...taProps} />
        </SectionDetails>
      </Section>
    </>
  );
}

HeadlineGrab.propTypes = {
  headlineGrab: PropTypes.string,
  onUpdate: PropTypes.func,
};

HeadlineGrab.defaultProps = {
  headlineGrab: null,
  onUpdate: () => null,
};
